module.exports = __webpack_public_path__ + "img/logotipo-unifrutti.7d7664e4.png";